import Datepicker from 'vuejs-datepicker';
import Multiselect from 'vue-multiselect'

import { mapGetters, mapMutations } from 'vuex';
import { orderService } from '../../services/OrderService';
import Loading from 'vue-loading-overlay';
import SearchBox from '../../views/Controls/SearchBox';
import OrderRemarks from './orderRemarks.vue';
import { listService } from '../../services/ListService';
import { userService } from '../../services/UserService';
import { strictEqual } from 'assert';
//import { Date } from 'core-js';

export default {
    name: 'OrderList',
    components: {
        Datepicker,
        Multiselect,
        Loading,
        SearchBox,
        OrderRemarks
    },
    props: {
        caption: {
            type: String,
            default: 'Polite expirate'
        },
    },
    data: () => {
        return {
            loading: true,

            currentPage: 1,
            perPage: 10,
            perPageOptions: [
                { text: '10', value: '10' },
                { text: '20', value: '20' },
                { text: '50', value: '50' },
                { text: '100', value: '100' },
            ],
            formTitle: '',
            focusedRowObject: null,
            selectedRowClass: 'secondary',
            fields: [],
            searchFilter: '',

            totalRows: 0,
            firstRowOnPage: 0,
            lastRowOnPage: 0,

            itemToBeChanged: null,


            propertyTypes: [],
            users: [],

            // stores selected item from mutiselect
            selectedOrderType: {},
            selectedOrderStatus: {},
            selectedUser: {},

            searchOrderParams:
            {
                EndDate: new Date(),
                StartDate: new Date(),
                OrderType: 0,
                InsuranceCompanies: [],
                UserId: '',
            },
        }
    },
    computed: {
        ...mapGetters(
            {
                // general
                userProfile: 'user/profile',
                userHasRole: 'user/hasRole',
                orderTypeSettings: 'general/orderTypeSettings',
                appSettings: 'general/appSettings',
                settingsLoaded: 'general/settingsLoaded',
                typeSettings: "general/typeSettings",
            }),


        orderTypes() {
            // return only active and user defined types
            var listOfOrderTypes = Object.values(this.orderTypeSettings);
            return listOfOrderTypes.filter(function (el) {
                return el.IsActive == true;
            });
        },

        orderStatusList() {
            return orderService.getOrderStatusList();
        },

        orderStatus() {
            return orderService.orderStatus;
        },

        roles() {
            return userService.roles;
        },

        canHandleOrders() {
            return this.userHasRole(this.roles.admin) || this.userHasRole(this.roles.operator);
        },

    },

    created() {

        // set default inerval as this month
        var date = new Date();
        this.searchOrderParams.StartDate = new Date(date.getFullYear(), date.getMonth(), 1);
        this.searchOrderParams.EndDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);


        this.propertyTypes = listService.getPropertyTypes();

        var model = this;
        userService.getUsers().then((response) => {
            model.users = response.data;
            model.loading = false;
        });

        this.fields = [
            { key: 'Type', label: 'Tip', sortable: true, thStyle: 'width:10%' },
            { key: 'OwnerName', label: 'Asigurat', sortable: true, thStyle: 'width:15%' },
            { key: 'Detail1', label: 'Bun asigurat', sortable: true, thStyle: 'width:15%' },
            { key: 'EndDate', label: 'Data expirarii', sortable: true, thStyle: 'width:15%' },
            { key: 'User', label: 'User', sortable: true, thStyle: 'width:5%' },
            { key: 'LastRemark', label: 'Observatii', sortable: true },
            { key: 'Policy', label: '', sortable: false, thStyle: 'width:15%' },
        ];
    },

    methods: {

        searchTextChanged: function (searchText) {
            this.refreshTable(searchText)
        },

        orderType_changed(value) {
            this.selectedOrderType = value;
            this.searchOrderParams.OrderType = value.Id;
        },
        user_changed(value) {
            this.selectedUser = value;
            this.searchOrderParams.UserId = value.Id;
        },
        status_changed(value) {
            this.selectedOrderStatus = value;
            this.searchOrderParams.Status = value.Value;

        },

        refreshTable: function (searchText) {

            console.log('searchTextChanged - searchFilter =' + searchText);
            this.searchFilter = searchText;
            this.$refs.ordersTable.refresh();

        },

        ordersDataProvider(ctx) {
            var self = this;
            self.loading = true;

            var params = {
                SortDesc: ctx.sortDesc,
                ShowAll: false,
                CurrentPage: ctx.currentPage,
                PerPage: ctx.perPage,
                SortBy: ctx.sortBy,
                SearchFilterObject: JSON.stringify(this.searchOrderParams),
                SearchFilter: this.searchFilter,
            };

            // get the page from server
            return orderService.getExpiringOrdersPage(params)
                .then(response => {
                    self.totalRows = response.data.RowCount;
                    self.firstRowOnPage = response.data.FirstRowOnPage;
                    self.lastRowOnPage = response.data.LastRowOnPage;

                    const items = response.data.Results || [];
                    self.loading = false;
                    return (items);
                })
                .catch(e => {
                    showErrorNotification(e);
                    self.loading = false;
                    return [];
                });

        },

        //
        renewButtonClick(data) {
            if (data != null) {
                this.$router.push({ name: 'renewOrder', params: { id: data.item.Id } });
            }
        },

        remarksButtonClick(data) {
            if (data != null) {
                this.itemToBeChanged = data.item;
            }
            this.$refs.orderRemarksModal.show();
        },
        saveRemarksButtonClick() {
            var model = this;
            this.$refs.orderRemarksComponent.save().then(() => {
                model.$refs.ordersTable.refresh();
            })
        },

        viewOrderButtonClick(data) {
            if (data != null) {
                this.$router.push({ name: 'editOffer', params: { id: data.item.NextOrderId } });
            }
        },

        searchButtonClick() {
            this.$refs.dropdownFilters.hide(true);
            this.$refs.ordersTable.refresh();
        },
        hideDropdown(bvEvt) {
            // refresh data
            this.$refs.ordersTable.refresh();
        },

        clearFiltersButtonClick() {
            // clear filters
            this.searchOrderParams =
            {
                EndDate: new Date(),
                StartDate: new Date(),
                OrderType: 0,
                Status: 0,
                InsuranceCompanies: [],
                UserId: '',
            };

            this.selectedOrderType = {};
            this.selectedOrderStatus = {};
            this.selectedUser = {};

            // refresh form
            this.$refs.dropdownFilters.hide(true);
            this.$refs.ordersTable.refresh();
        },

        //
        getAuditInfoHtml(data) {
            var html = '<div class="small text-muted">Adaugat:&nbsp;<b>' + data.item.CreatedBy + '</b>&nbsp;' + data.item.RelativeCreatedOn + ' </div >';
            if (data.item.UpdatedBy != null) {
                html += '<div class="small text-muted">Modificat:&nbsp;<b>' + data.item.UpdatedBy + '</b>&nbsp;' + data.item.RelativeUpdateddOn + ' </div >';
            }
            return html;
        },

        getStatusVariant(item) {

            var badgeVariant = 'primary';
            if (item.NextOrderId != null) {
                // policy was renewed
                badgeVariant = 'success'
            }
            else {

                var date = new Date();

                var today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                var endDate = new Date(item.EndDate);
                if (endDate > today) {
                    // not renewed and not expired
                    badgeVariant = 'warning';
                }
                else {
                    badgeVariant = 'danger';
                }
            }

            return badgeVariant;
        },

        getStatusText(item) {
            var badgeText = '';
            if (item.NextOrderId != null) {
                // policy was renewed
                badgeText = 'Reînnoită'
            }
            else {
                badgeText = 'De reînnoit';
            }

            return badgeText;
        },

        getPeriodType(type) {

            switch (type.JsonSettings.PeriodType) {
                case 0: 
                    return  'luni';
                    break;
                case 1: 
                    return 'ani';
                    break;
                case 2: 
                    return 'zile';
                    break;
            }
        },

        getNextOrderStatusText(status) {
            var badgeText = 'Oferta';

            switch (status) {
                case 0: // new
                    badgeText = 'Cerere';
                    break;
                case 1: //in progress
                    badgeText = 'În lucru';
                    break;
                case 2: // Done
                    badgeText = 'Comanda';
                    break;
                case 4: //Policy = 4, // Policy issued
                    badgeText = 'Polița emisă';
                    break;
                case 5: //Canceled = 5, // policy canceled
                    badgeText = 'Anulată';
                    break;
                case 6: //Blocked = 5, // policy canceled
                    badgeText = 'Blocată';
                    break;
                default:
                    badgeText = 'De reînnoit';
                    break;
            }

            return badgeText;
        },

        //
        setItemToBeChanged(data) {
            if (data != null) {
                this.itemToBeChanged = data.item;
            }
        },

        zeroPad(num, places) {
            var zero = places - num.toString().length + 1;
            return Array(+(zero > 0 && zero)).join("0") + num;
        },

        doNotCallAnymore: function (data) {
            const text = 'Reînnoită în altă parte.'
            orderService.saveOrderRemarks(data.item.Id, text)
                .then(function () {
                    data.item.LastRemark = text;
                })
                .catch(e => {
                    showErrorNotification(e);
                    reject(e);
                });
        }
    }
}
